export default "__VITE_ASSET__Cn2XMleG__"